var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2404 0.0550291L14.9463 4.76123C15.0199 4.8346 15.0199 4.95473 14.9463 5.02834L13.3436 6.63069C13.2701 6.70443 13.15 6.70443 13.0766 6.63069L12.621 6.17532L10.5086 8.28736C10.9825 10.0723 10.5202 12.0545 9.12049 13.4539C9.08802 13.4867 9.05518 13.5185 9.02185 13.55C8.89928 13.6666 8.91893 13.6659 8.80051 13.5475L5.81081 10.5577L0 15L4.44372 9.19078L1.44962 6.19693C1.33022 6.07728 1.34023 6.09609 1.45768 5.97266C1.48698 5.94202 1.51689 5.91125 1.54729 5.88073C2.94673 4.48129 4.92924 4.01859 6.7141 4.49264L8.82627 2.3806L8.37053 1.92498C8.29716 1.85161 8.29716 1.73148 8.37053 1.65786L9.97312 0.0550291C10.0469 -0.018343 10.167 -0.018343 10.2404 0.0550291Z",
    fill: "#F5F6F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVector);
export default __webpack_public_path__ + "static/media/icon-vector.256ecdc25bc0f4a64c48cdf7990a91a6.svg";
export { ForwardRef as ReactComponent };